import { Component, OnInit } from '@angular/core';
import { LibraryService,MentorService,MasterService} from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-assignact',
  templateUrl: './assignact.component.html',
  styleUrls: ['./assignact.component.scss'],
  providers:[LibraryService,MentorService,MasterService]
})
export class AssignactComponent implements OnInit {

  

    // books: Book[];
     memberdetails:any[]=[];
     classdetails:any[]=[];
     closeResult: string;
    
     student:boolean=true;
     staff:boolean=false;
     memberdash:any={};
     arrschh=[];
     arrschd=[];
     arrclass=[];
     arrstudent=[];
     selcls:any;
     selstu:any;
     objschh:any={};
     stfid:any;
     objschd:any={};
     status='Pending';

     modalOptions:NgbModalOptions;
     private modalRef: NgbModalRef;
     fserdt:any;
     fserdt4:any;
     classes=[];
     selclass:any;
     schdt:any;
  arrcourse: any;
  sections: any;
   fmodel:any={};
  fmodel1:any={};
  stualloted: any;
    completeDate: Date;
  localCompleteDate: string;
  arrstualloted: any=[];
   selstudent:any={};
     constructor(private http: HttpClient, private liservice: LibraryService,private mentservice: MentorService,private modalService: NgbModal,private mservice: MasterService) 
     {

      this.fmodel.emid=localStorage.getItem('usid');
    var d=new Date();
    this.fserdt=this.mentservice.getdatetoday();
    this.fserdt4=this.mentservice.getdatetoday();
    this.schdt=this.mentservice.getdatetoday();

       this.completeDate = new Date();
    this.localCompleteDate = this.completeDate.toISOString();
    this.localCompleteDate = this.localCompleteDate.substring(0, 16).replace("T"," ");
    this.mascourse();
      }
   
     open(content) {
       this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
         this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
         this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
       });
     }
   
     private getDismissReason(reason: any): string {
       if (reason === ModalDismissReasons.ESC) {
         return 'by pressing ESC';
       } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
         return 'by clicking on a backdrop';
       } else {
         return `with: ${reason}`;
       }
     }
   
   
   
     ngOnInit(): void {
       
       this.getschedules('selschmenbystat');
      
     }

   
  mascourse() {
        this.mservice.mascourse()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrcourse = resultArray;
                this.fmodel.crid=resultArray[0].crid;
                 this.fmodel1.crid=resultArray[0].crid;
                this.masclass();
                //this.fmodel1.crid=resultArray[0].crid;
            },
            error => console.log("Error :: " + error)
            )
      }

      masclass() {
      // this.mservice.classmasterrolewise(0,this.fmodel.crid,0,'class')
        this.mservice.masclass()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.classes = resultArray;
              this.fmodel.clid=resultArray[0].clid;
              this.fmodel1.clid=resultArray[0].clid;
              this.massection();
            //  this.masperiod();
              
             
          },
          error => console.log("Error :: " + error)
          )
    }

  massection() {
      // this.mservice.sectionsrolewise(0,this.fmodel.crid,this.fmodel.clid,'section')
       this.mservice.massection()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.sections = resultArray;
              this.fmodel.scid=resultArray[0].scid;
               this.fmodel1.scid=resultArray[0].scid;
             // this.masasshead();
            //  this.getstudentdata('sel_alloted', this.fmodel);
          },
          error => console.log("Error :: " + error)
          )
    }

     onmemberselectEvent(item) {
//alert('hi');
    console.log('item',item);
    // this.objlevel.duration=item.duration;
    this.fmodel.stuid=item.stuid;
   }

     onmemberChangeSearch(sertxt) {
    debugger
  

  

  this.arrstualloted= this.stualloted.filter(item => {
      
      const nameMatches = item.stunm.toLowerCase().includes(sertxt.toLowerCase());
     
      return nameMatches ; 
    });
    console.log('arflstudent',this.arrstualloted);
  }
 
  onDropDownClick(event: any) {
    this.arrstualloted = this.stualloted; // Show the full list

    // Manually toggle the dropdown visibility if needed, as default behavior can vary
    event.originalEvent.preventDefault();
    event.originalEvent.stopPropagation();

    // if (this.autoCompleteComponent.overlayVisible) {
    //   this.autoCompleteComponent.hide();
    // } else {
    //   this.autoCompleteComponent.show();
    // }
  }
    

     getstudentdata(oprtype,obj) {
    this.mentservice.getstualloted(obj.emid,obj.clid,obj.scid,obj.crid,oprtype)
        .subscribe(
        resultArray => {
            console.log('members-result', resultArray);
           //resultArray.splice(0,1);
           if (oprtype=='sel_alloted')
           {
            this.stualloted=resultArray;
            // this.fmodel.stuid=resultArray[0].stuid;
           }
            else if(oprtype=='sel_nonalloted')
            {
              // this.stuavailable=resultArray;

            }
            
        },
        error => console.log("Error :: " + error)
        )
  }

     getschedules(oprtype) {
       debugger;
       this.mentservice.getmentschedules(oprtype,this.status,this.fserdt4)
           .subscribe(
           resultArray => {
               console.log('members-result', resultArray);
             
               this.arrschh = resultArray;
             
               
           },
           error => console.log("Error :: " + error)
           )
     }
    //  getstudentdata(oprtype) {
    //   this.mentservice.getstualloted(this.selclass,this.stfid,oprtype)
    //       .subscribe(
    //       resultArray => {
    //           console.log('members-result', resultArray);
            
    //           this.arrstudent=resultArray;
    //           this.objschh.stuid=0;
              
    //       },
    //       error => console.log("Error :: " + error)
    //       )
    // }

    Savedtls()
    {

      debugger;
    if(this.fmodel.stuid==undefined || this.fmodel.stuid==0 || this.fmodel.stuid=='')
    {

      alert ('Please select student');
      return;
    }
    else if(this.fmodel.schtitle==undefined || this.fmodel.schtitle=='')
    {
      alert ('Please enter schedule Title');
      return;
    }
      this.mentservice.savementschedules(this.fmodel,this.fmodel.oprtype)
      .subscribe(
      resultArray => {
          console.log('members-result', resultArray);
         //resultArray.splice(0,1);
         alert(resultArray.message);
         this.getschedules('selschmenbystat');
         if(resultArray.status=='Success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
            // this.getschedules('selschh','0');

          }
        
          
      },
      error =>{
        console.log("Error :: " + error);
        alert('Error while processing data');
      } 
      )
    }


     delschedule(obj)
    {

      if(confirm('Are you sure to delete this schedule?'))
      {
        this.fmodel=obj;
      this.mentservice.savementschedules(this.fmodel,"delsch")
      .subscribe(
      resultArray => {
          console.log('members-result', resultArray);
         //resultArray.splice(0,1);
         alert(resultArray.message);
         this.getschedules('selschmenbystat');
         
        
          
      },
      error =>{
        console.log("Error :: " + error);
        alert('Error while processing data');
      } 
      )
    }
    }
    Saveremarkdtls()
    {

      debugger;
      console.log('Savedtls',this.objschd);
      this.mentservice.savementreviews(this.objschd)
      .subscribe(
      resultArray => {
          console.log('members-result', resultArray);
         //resultArray.splice(0,1);
         alert(resultArray.message);
         if(resultArray.status=='Success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
            //this.getschedules('selschh','0');
            this.objschd={};
            this.getschedules('selschmen');

          }
         else
         {

         }
          
      },
      error =>{
        console.log("Error :: " + error);
        alert('Error while processing data');
      } 
      )
    }

     memberdashcnts(oprtype) {
       this.liservice.getmemberdetails(oprtype,'',0,0)
           .subscribe(
           resultArray => {
               console.log('members-result', resultArray);
               this.memberdash = resultArray[0];
               
           },
           error => console.log("Error :: " + error)
           )
     }

     masclassdetails() {
      this.mentservice.classmaster()
          .subscribe(
          resultArray => {
              console.log('members-result', resultArray);
             //resultArray.splice(0,1);
              this.objschh.clid=resultArray[0].clid;
              this.selcls=resultArray[0].clid;
              this.arrclass=resultArray;
              //let resSTR = JSON.stringify(resultArray);
            
              //this.composefilterclass(resSTR);
              
          },
          error => console.log("Error :: " + error)
          )
    }
    openinfo(content,cmd,obj)
    {
      debugger;
      if(cmd=='inssch')
      {
        // this.fmodel={};
        this.fmodel.schid=0;
        this.fmodel.schdt=this.localCompleteDate;
        this.fmodel.emid=localStorage.getItem('usid');
        this.fmodel.oprtype='insch';
        this.getstudentdata('sel_alloted', this.fmodel);
      
      }

      else if(cmd =='updsch')
      {
        
        //  this.mascourse();
        
        this.fmodel=obj;
        this.fmodel.oprtype='updsch';
      }
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'md'
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           // this.Asmtdetls(asid);
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            
        });
    }

    openremark(content,frmdata)
    {
      this.objschd=frmdata;
      //this.getstudentdata('sel_nonalloted');
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop'
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           // this.Asmtdetls(asid);
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            
        });
    }
    
   
     
   
    
   
   
    
   }
